import { useContext } from "react";
import { makeStyles, Grid, Button, Container } from "@material-ui/core";
import { Save as SaveIcon } from '@material-ui/icons';
import { Field, Form, Formik } from "formik";
import { Page } from "components";
import { serialNumberContext } from "./SerialNumberProvider";
import { TextField } from "formik-material-ui";


let useStyles = makeStyles(theme => ({
    button: {
        marginTop: 16,
        float: "right"
    }
}));

let SerialNumber = () => {
    let classes = useStyles();

    let service = useContext(serialNumberContext);

    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title='Add serial number'
                isLoading={false}
            >
                <Formik
                    enableReinitialize={true}
                    initialValues={service.serialNumberSchema.getDefault()}
                    validationSchema={service.serialNumberSchema}
                    onSubmit={async (values, action) => {
                        action.setSubmitting(true);
                        await service.saveNewSerialNumber(values);
                    }}
                >
                    <Form>
                        <Grid container>
                            <Grid item xs>
                                <Field
                                    component={TextField}
                                    label="Serial number"
                                    name="serialNumber"
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                        <Button
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            <SaveIcon />&nbsp; Save
                        </Button>
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default SerialNumber;